module.exports = {
  RESULTS: {
    SURVEY: {
      ROLE: 'Results - Survey - Role',
      PURPOSE: 'Results - Survey - Purpose',
      PROFILE: 'Results - Survey - Profile',
      GEO: 'Results - Survey - Geo',
      FIND: 'Results - Survey - Find Analysis',
      GRADES: 'Results - Survey - Grades',
      NPS: 'Results - Survey - NPS',
      CSI: 'Results - Survey - CSI',
      MISC: 'Results - Survey - Miscellaneous',
    },
    FEEDBACK: 'Results - Feedback',
  },
  ROLE: 'Role',
  PURPOSE: 'Purpose',
  GRADE: {
    GENERIC: 'Grade',
    OVERALL: 'Grade - Overall',
    GRAPHIC: 'Grade - Graphic',
    GRAPHIC_VISUAL_IMPRESSION: 'Grade - Graphic - Visual impression',
    STRUCTURE: 'Grade - Structure',
    STRUCTURE_SEARCH: 'Grade - Structure - Search',
    STRUCTURE_MENU: 'Grade - Structure - Menu',
    STRUCTURE_PRODUCT_FINDER: 'Grade - Structure - Product Finder',
    INFORMATION: 'Grade - Information',
    INFORMATION_PRODUCT: 'Grade - Information - Product',
    INFORMATION_CONTACT: 'Grade - Information - Contact',
    USER_FRIENDLINESS: 'Grade - User friendliness',
    EXPECTATIONS: 'Grade - Expectations',
  },
  FIND: 'Find',
  NPS: {
    NPS_WEB: 'NPS - Website',
    NPS_BRAND: 'NPS - Brand',
  },
  CSI: {
    IDEAL: 'CSI - Ideal',
    EXPECTANCY: 'CSI - Expectancy',
    SATISFACTION: 'CSI - Satisfaction',
  },
  PROFILE: {
    AGE: 'Age',
    GENDER: 'Gender',
    EDUCATION: 'Education',
    FIRST_TIME_VISITOR: 'First time visitor',
    INTERNET_USAGE: 'Internet usage',
    DEVICE: 'Device',
  },
  GEO: {
    ZIP: 'Zip',
    COUNTRY: 'Country',
  },
  COLOR: {
    BY_VALUE: 'Grade color by value',
    BY_INDEX: 'Grade color by index',
  },
  BENCHMARK: {
    EXCLUDE: 'Exclude from benchmark',
  },
};
